import React, { useState } from 'react';
import { AdminProductsEnhancedPage } from './AdminEnhanced';
import { AdminCategoriesTab, AdminTechniquesTab, AdminDelaysTab, AdminSizesTab } from './AdminEnhanced2';

/* ═══════════════════════════════════════════════════════════
   MODULE PRODUITS COMPLET — Produits + Catégories + Techniques
   ═══════════════════════════════════════════════════════════ */
export const AdminProductsWithCatalogPage = () => {
  const [activeTab, setActiveTab] = useState('products');

  const tabs = [
    { key: 'products',   label: 'Produits' },
    { key: 'categories', label: 'Catégories' },
    { key: 'techniques', label: 'Techniques' },
    { key: 'sizes',      label: 'Tailles' },
    { key: 'delays',     label: 'Délais' },
  ];

  return (
    <div style={{ display: 'flex', flexDirection: 'column', flex: 1 }}>
      {/* Tab bar */}
      <div style={{
        display: 'flex',
        gap: 4,
        padding: '12px var(--space-xl) 0',
        borderBottom: '1px solid var(--border)',
        background: 'var(--bg-card)',
        marginBottom: 0,
        flexShrink: 0,
      }}>
        {tabs.map(t => (
          <button
            key={t.key}
            onClick={() => setActiveTab(t.key)}
            style={{
              padding: '10px 20px',
              fontSize: 14,
              fontWeight: 600,
              border: 'none',
              cursor: 'pointer',
              background: 'none',
              borderBottom: activeTab === t.key ? '3px solid var(--brand-accent)' : '3px solid transparent',
              color: activeTab === t.key ? 'var(--brand-accent)' : 'var(--text-secondary)',
              transition: 'all .15s',
              marginBottom: -1,
            }}
          >
            {t.label}
          </button>
        ))}
      </div>

      {/* Tab content */}
      <div style={{ flex: 1, display: 'flex', flexDirection: 'column', overflow: 'hidden' }}>
        {activeTab === 'products' && <AdminProductsEnhancedPage />}

        {activeTab === 'categories' && (
          <div style={{ padding: 'var(--space-xl)', display: 'flex', flexDirection: 'column', gap: 'var(--space-md)', flex: 1, overflowY: 'auto' }}>
            <div>
              <h1 style={{ fontSize: 24, fontWeight: 800, marginBottom: 4 }}>Catégories</h1>
              <p style={{ fontSize: 13, color: 'var(--text-muted)' }}>Gérez les catégories de votre catalogue</p>
            </div>
            <AdminCategoriesTab />
          </div>
        )}

        {activeTab === 'techniques' && (
          <div style={{ padding: 'var(--space-xl)', display: 'flex', flexDirection: 'column', gap: 'var(--space-md)', flex: 1, overflowY: 'auto' }}>
            <div>
              <h1 style={{ fontSize: 24, fontWeight: 800, marginBottom: 4 }}>Techniques de marquage</h1>
              <p style={{ fontSize: 13, color: 'var(--text-muted)' }}>Gérez les techniques disponibles et leur tarification</p>
            </div>
            <AdminTechniquesTab />
          </div>
        )}

        {activeTab === 'sizes' && (
          <div style={{ padding: 'var(--space-xl)', display: 'flex', flexDirection: 'column', gap: 'var(--space-md)', flex: 1, overflowY: 'auto' }}>
            <div>
              <h1 style={{ fontSize: 24, fontWeight: 800, marginBottom: 4 }}>Tailles</h1>
              <p style={{ fontSize: 13, color: 'var(--text-muted)' }}>Gérez les tailles disponibles dans les fiches produits</p>
            </div>
            <AdminSizesTab />
          </div>
        )}

        {activeTab === 'delays' && (
          <div style={{ padding: 'var(--space-xl)', display: 'flex', flexDirection: 'column', gap: 'var(--space-md)', flex: 1, overflowY: 'auto' }}>
            <div>
              <h1 style={{ fontSize: 24, fontWeight: 800, marginBottom: 4 }}>Délais de production</h1>
              <p style={{ fontSize: 13, color: 'var(--text-muted)' }}>Gérez les délais disponibles dans le studio de commande</p>
            </div>
            <AdminDelaysTab />
          </div>
        )}
      </div>
    </div>
  );
};

export default AdminProductsWithCatalogPage;
